import { Injectable } from '@angular/core';
import {
  AssistantDocumentDetails,
  AssistantSearch,
} from '@vi-iot/client/apis/assistant/assistant.api-model';
import {
  AssistantDocumentType,
  AssistantImages,
  assistantSupportedLanguagesList,
} from './assistant.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssistantHelperService {
  isLanguageSupported$ = new BehaviorSubject<boolean>(null);

  constructor() {}

  getImagesSrcFromHtmlContent(htmlContent: string): string[] {
    const parser: DOMParser = new DOMParser();
    const doc: Document = parser.parseFromString(htmlContent, 'text/html');
    const imgElements: NodeListOf<HTMLImageElement> = doc.querySelectorAll('img');
    const imagesSrc: string[] = [];

    imgElements.forEach((imgElement: HTMLImageElement) => {
      const src: string = imgElement.getAttribute('src');
      if (src) {
        imagesSrc.push(src);
      }
    });

    return imagesSrc;
  }

  getResourceId(selectedDocument: AssistantSearch): string {
    const regex = /([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})(\.?[a-z0-9]+)?/;
    const match: RegExpMatchArray = selectedDocument.downloadLink.match(regex);

    return match ? match[0] : null;
  }

  replaceImagesInHtmlContent(
    htmlContent: string,
    fetchedImages: AssistantImages[],
    path: string
  ): string {
    const parser: DOMParser = new DOMParser();
    const doc: Document = parser.parseFromString(htmlContent, 'text/html');
    const contentImages: HTMLImageElement[] = Array.from(doc.querySelectorAll('img'));
    contentImages.forEach((contentImage: HTMLImageElement) => {
      const contentImageName = contentImage.src.includes(path)
        ? decodeURIComponent(contentImage.src.split(`${path}/`)[1])
        : decodeURIComponent(contentImage.src.split(`${window.location.host}/`)[1]);

      // Alt mapping  could cause bugs, real-life scenario:
      // alt="Schrauben für Lüfterausrichtung.png"
      // src="Schrauben für Lüfterausrichtung (1).png"

      const imageBlob: Blob = fetchedImages.find(
        (fetchedImage: AssistantImages) => contentImageName === fetchedImage.name
      ).blob;
      if (imageBlob) {
        contentImage.src = URL.createObjectURL(imageBlob);
      }
    });

    return doc.body.innerHTML;
  }

  getDocumentType(document: AssistantSearch | AssistantDocumentDetails): AssistantDocumentType {
    if (document.downloadLink && document.downloadLink.includes('pdf')) {
      return AssistantDocumentType.pdf;
    } else if (document.documentType?.value === AssistantDocumentType.decisionTree) {
      return AssistantDocumentType.decisionTree;
    } else {
      return AssistantDocumentType.html;
    }
  }

  getAssistantPayloadLanguage(langCode: string): string {
    const shortLangCode = langCode.split('-')[0];

    return assistantSupportedLanguagesList.includes(shortLangCode) ? shortLangCode : null;
  }
}
